import Vue from 'vue'
import Vuex from 'vuex'
import common from './modules/common'
import user from './modules/user'
import appointment from './modules/appointments'
import videocall from './modules/videocall'
import UI from './modules/UI'
import socket from './modules/socket'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

// Define Store Function
export default new Vuex.Store({
  strict: debug,
	modules: {
    common:common,
    user:user,
    appointment:appointment,
    videocall:videocall,
    UI,
    socket
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js